import * as Yup from "yup";

const TypeCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
});
export default TypeCreationSchema;
